import { Link } from 'react-router';

const links = [
  { to: '/councils', label: 'Find your council data' },
  { to: '/authority-ratings', label: 'Search England ratings' },
  { to: '/road-maintenance-report', label: 'Read the national report' },
  { to: '/data/council-road-maintenance-ratings', label: 'Open the dataset' },
  { to: '/check', label: 'Check claim eligibility' },
] as const;

export function CouncilDataCallout() {
  return (
    <aside
      aria-labelledby="council-data-callout-heading"
      className="mb-8 rounded-2xl border border-brand-200 bg-brand-50 p-6"
    >
      <h2 id="council-data-callout-heading" className="font-display text-xl font-bold text-brand-950">
        Check the council data, then verify the incident evidence
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-surface-700">
        Fixtyer&apos;s DfT ratings and council reports cover English highway authorities only. They provide
        network-level context and do not prove notice, a breach of duty or liability for a particular defect.
        A FixMyStreet report is a lead to verify against the council&apos;s records, not proof the authority
        received it.
      </p>
      <nav aria-label="Council data and claim tools" className="mt-4">
        <ul className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
          {links.map((link) => (
            <li key={link.to}>
              <Link className="font-semibold text-brand-700 underline underline-offset-2" to={link.to}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
